import { createSelector } from 'reselect'

import libraryObjectNone from 'helpers/libraries/libraryObjectNone'

const getLessons = state => state.lessons

const getLessonByUid = (lessons, lessonUid) => (
	lessons[lessonUid] ? lessons[lessonUid] : libraryObjectNone
)

export default createSelector(
	[ getLessons ],
	lessons => lessonUid => getLessonByUid(lessons, lessonUid)
)
